import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Trip } from "@mapmycustomers/shared/types/entity";
import { UpdateTripPayload } from "@mapmycustomers/shared/types/entity/Trip";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import FieldTimeCardData from "@app/scene/dashboard/store/cards/fieldTime/FieldTimeCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import FieldTimeCardConfiguration from "@app/types/dashboard/cards/fieldTime/FieldTimeCardConfiguration";
import DashboardCard from "@app/types/dashboard/DashboardCard";
import Scope from "@app/types/dashboard/Scope";

export const fetchFieldTimeCardData = createAction("@dashboard/fetchFieldTimeCardData")<{
  callback: (data: FieldTimeCardData) => void;
  cardId: DashboardCard["id"];
  configuration: FieldTimeCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showFieldTimeDrillDown = createAsyncAction(
  "@dashboard/showFieldTimeCardDrillDownModal/request",
  "@dashboard/showFieldTimeCardDrillDownModal/success",
  "@dashboard/showFieldTimeCardDrillDownModal/failure"
)<
  {
    configuration: FieldTimeCardConfiguration;
    customDateRange?: DateRange;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  void
>();

export const hideFieldTimeDrillDown = createAction(
  "@dashboard/hideFieldTimeCardDrillDownModal"
)<void>();

export const fetchFieldTimeCardDrillDownData = createAsyncAction(
  "@dashboard/fetchFieldTimeCardDrillDownData/request",
  "@dashboard/fetchFieldTimeCardDrillDownData/success",
  "@dashboard/fetchFieldTimeCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<Trip>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  void
>();

export const applyFieldTimeDrillDownListViewSettings = createAction(
  "@dashboard/applyFieldTimeDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportFieldTimeCardDrillDownData = createAction("@dashboard/exportFieldTimeCardData")<{
  configuration: FieldTimeCardConfiguration;
  scope: Scope;
}>();

export const updateFieldTimeTrip = createAsyncAction(
  "@dashboard/updateFieldTimeTrip/request",
  "@dashboard/updateFieldTimeTrip/success",
  "@dashboard/updateFieldTimeTrip/failure"
)<
  { entity: UpdateTripPayload; onFailure?: () => void; onSuccess?: (trip: Trip) => void },
  Trip,
  void
>();

export type FieldTimeCardActions = ActionType<
  | typeof applyFieldTimeDrillDownListViewSettings
  | typeof exportFieldTimeCardDrillDownData
  | typeof fetchFieldTimeCardData
  | typeof fetchFieldTimeCardDrillDownData
  | typeof hideFieldTimeDrillDown
  | typeof showFieldTimeDrillDown
  | typeof updateFieldTimeTrip
>;
